import React, {useState, useContext} from "react";
import axios from "axios";

import GlobalContext from "../../context/GlobalContext";

import { Form } from "react-bootstrap";

import { Input, TextArea, Button } from "../Core";

const ContactForm = ({ theme = "dark", ...rest }) => {
  const gContext = useContext(GlobalContext);
  const [email, setEmail] = useState(null);
  const [name, setName] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState("");
  const [disability, setDisability] = useState(false);

  const settings = gContext.getSettings();

  const submitMessage = () => {
    //    alert(name+ " " + email + " " + message);
    setDisability(true);
    axios.post(settings.apiUrl + '/contact', {
      name: name,
      email: email,
      message: message,
    })
    .then(function (response) {
      gContext.toggleContact();
    })
    .catch(function (error) {
      setError("Sorry, something went wrong. Please try again in a bit or send an email to oozie@trullla.com")
      console.log(error);
      setDisability(false);
    });

  }

  return (
    <>
      <div style={{color: "red"}}>
        {error}
      </div>
      <div className="mt-4">
        <Input type="text" placeholder="Your name" required name="name"
          onChange={(e)=>setName(e.target.value)} />
      </div>
      <div className="mt-4">
        <Input type="email" placeholder="Email address" required name="email"
          onChange={(e)=>setEmail(e.target.value)} />
      </div>
      <div className="mt-4 ">
        <TextArea
          rows={4}
          placeholder="Write your message"
          required
          name="message"
          onChange={(e)=>setMessage(e.target.value)} />
      </div>
      <div className="mt-4 mt-lg-5">
        <Button arrowRight onClick={submitMessage} variant={disability ? "secondary" : "primary"} disabled={disability} >
          SEND
        </Button>
      </div>
    </>
  );
};

export default ContactForm;
